import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalTerminoCondicionesComponent } from '../../layouts/modal-termino-condiciones/modal-termino-condiciones.component';
import { RegistroCuentaService } from './registro-cuenta.service';
import { BasicasLoVService } from 'src/app/shared/services/basicas-lov.service';
import { TipoIdentificacionEntry } from 'src/app/shared/entrys/tipo_identificacion.entry';
import { ModalRecupContraComponent } from '../../layouts/modal-recup-contra/modal-recup-contra.component';
import { TerminosCondicionesService } from 'src/app/shared/services/terminos-condiciones.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { PrestadorEntry } from 'src/app/shared/entrys/prestador.entry';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
// tslint:disable-next-line:max-line-length
import { ConfirmarRespuestaModel, ConfirmarRespuestaType, TipoConfirmacionModalType } from 'src/app/shared/models/confirmar-respuesta.model';
import { TipoPrestador } from 'src/app/shared/enumeraciones/tipo-prestador.enum';
import { Router } from '@angular/router';
import { TipoCorreo } from 'src/app/shared/enumeraciones/tipo-correo.enum';
import { environment } from 'src/environments/environment.training';
import { filter } from 'rxjs/operators';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
	selector: 'app-registro-cuenta',
	templateUrl: './registro-cuenta.component.html',
	styleUrls: ['./registro-cuenta.component.scss']
})


export class RegistroCuentaComponent implements OnInit {
	formRegistroCuenta: FormGroup;
	tipos_identificaciones: Array<TipoIdentificacionEntry>;
	texto_aceptacion_terminos: string = "";
	private dataVerificacion: {
		nombre_representante_legal: string,
		correo_electronico: string,
		tipo_prestador: string,
		tipo_prestador_id: string
	};

	constructor(private basicasLoVService: BasicasLoVService,
		private terminosCondicionesService: TerminosCondicionesService,
		private modalService: NgbModal, private formBuilder: FormBuilder,
		private registroServicio: RegistroCuentaService, private alertService: AlertsService,
		private router: Router) {
		this.dataVerificacion = {} as {
			nombre_representante_legal: string,
			correo_electronico: string,
			tipo_prestador: string,
			tipo_prestador_id: string
		};
	}

	ngOnInit() {
		this.formRegistroCuenta = this.formBuilder.group({
			usuario: ['', [Validators.required, ConfirmeValidators.usernameValidator]],
			tipo_identificacion_id: ['', Validators.required],
			correo_electronico: [{ value: '', disabled: true }, [Validators.required, ConfirmeValidators.emailValidator]],
			//correo_electronico: ['', [Validators.required, ConfirmeValidators.emailValidator]],
			numero_identificacion: ['', [Validators.required, ConfirmeValidators.numberValidator]],
			contrasenaGroup: this.formBuilder.group({
				clave_acceso: ['', [Validators.required, ConfirmeValidators.passwordValidator]],
				clave_acceso_confirmacion: ['', Validators.required]
			}, { validator: ConfirmeValidators.childrenEqual }),
			nombre_representante_legal: ['', Validators.required],
			digito_verificacion: ['', [Validators.required,Validators.pattern('^[0-9]*$'),Validators.maxLength(1)]],
			captcha: ['', Validators.required],
			tipo_prestador_id: [{ value: '', disabled: true }, Validators.required],
			tipo_prestador: [{ value: '', disabled: true }, Validators.required],
			permite_recibir_notificaciones: [false, Validators.requiredTrue],
			acepta_terminos_condiciones: [false, Validators.requiredTrue]
		});
		this.basicasLoVService.getTiposIdentificacion(null).subscribe(resultado => {
			if (resultado.result) {
				this.tipos_identificaciones = resultado.data.filter(x=> x.permite_crear_usuario && x.tipo_identificacion_id == 2) as Array<TipoIdentificacionEntry>;
			}
		});
		this.registroServicio.getParametro({
			parametro_id: 'TEXTO_TRATAMIENTO_DATOS_REGISTRO',
			agrupacion: 'TRATAMIENTO_DATOS',
			auxiliar: '1'
		}).subscribe(resultado => {
			if (resultado.result) {
				this.texto_aceptacion_terminos = resultado.data;
			}
		});
	}

	openModal() {
		const modalRef = this.modalService.open(ModalTerminoCondicionesComponent, { centered: true, size: 'lg' });
		this.terminosCondicionesService.getTextoPlano(null).subscribe(resultTC => {
			if (resultTC.result) {
				modalRef.componentInstance.terminos = resultTC.data[0];
				modalRef.result.then(resultModalTC => {
					if (this.formRegistroCuenta.valid) {
						let prestador = {} as PrestadorEntry;
						if (this.dataVerificacion.tipo_prestador_id === TipoPrestador.Comerciante) {
							prestador = {
								...this.formRegistroCuenta.value,
								...this.formRegistroCuenta.value.contrasenaGroup,
								tipo_prestador_id: this.dataVerificacion.tipo_prestador_id,
								// FIXME: Descomentar lineas al finalizar pruebas
								// #region Habilitar
								correo_electronico: this.dataVerificacion.correo_electronico,
								// #endregion
							} as PrestadorEntry;
						} else {
							prestador = {
								...this.formRegistroCuenta.value,
								...this.formRegistroCuenta.value.contrasenaGroup,
								// FIXME: Descomentar lineas al finalizar pruebas
								// #region Habilitar
								correo_electronico: this.dataVerificacion.correo_electronico,
								// #endregion
								tipo_prestador_id: this.dataVerificacion.tipo_prestador_id,
								nombre_representante_legal: this.dataVerificacion.nombre_representante_legal ?
									this.dataVerificacion.nombre_representante_legal : this.formRegistroCuenta.value.nombre_representante_legal
							} as PrestadorEntry;
						}
						prestador.permite_recibir_notificaciones = !prestador.permite_recibir_notificaciones ? false : true;
						this.registroServicio.create(
							{
								...prestador,
								clave_acceso: UtilService.encrypt(prestador.clave_acceso),
								clave_acceso_confirmacion: UtilService.encrypt(prestador.clave_acceso_confirmacion)
							}
							).subscribe((resultado) => {
							if (resultado.result) {
								this.terminosCondicionesService.aceptarTerminos(prestador).subscribe(resultadoAcepto => {
									if (resultadoAcepto.result) {
										const modalRefConfirmacion = this.modalService.open(ModalRecupContraComponent, { centered: true });
										modalRefConfirmacion.result.then(resultConfir => {
											this.formRegistroCuenta.reset();
											this.registroServicio.reenviar({
												...resultado.data,
												tipo_correo: TipoCorreo.Registro,
											}).subscribe(res => {
												this.router.navigate(['/home']);
											});
										}).catch(salir => {
											this.formRegistroCuenta.reset();
										});
									}
								});
							}
						});
					}
				});
			}
		});
	}

	onValidarPrestador() {
		if (this.formRegistroCuenta.value.numero_identificacion
			&& this.formRegistroCuenta.value.digito_verificacion
			&& this.formRegistroCuenta.value.tipo_identificacion_id) {
			this.registroServicio
				.get({
					nit: this.formRegistroCuenta.value.numero_identificacion,
					dv: this.formRegistroCuenta.value.digito_verificacion,
					tipo_identificacion_id: this.formRegistroCuenta.value.tipo_identificacion_id
				}).subscribe((resultado) => {
					if (resultado.result) {
						this.dataVerificacion = resultado.data;
						this.formRegistroCuenta.controls['nombre_representante_legal'].patchValue(this.dataVerificacion.nombre_representante_legal);
						this.formRegistroCuenta.controls['correo_electronico'].setValue(this.dataVerificacion.correo_electronico);
						if (this.dataVerificacion.nombre_representante_legal && this.dataVerificacion.nombre_representante_legal.trim().length > 1) {
							this.formRegistroCuenta.controls['nombre_representante_legal'].disable();
						} else {
							this.formRegistroCuenta.controls['nombre_representante_legal'].enable();
						}
						this.formRegistroCuenta.controls['tipo_prestador'].setValue(this.dataVerificacion.tipo_prestador);
						this.formRegistroCuenta.controls['tipo_prestador_id'].setValue(this.dataVerificacion.tipo_prestador_id);
					}
					if (!this.dataVerificacion.correo_electronico || this.dataVerificacion.tipo_prestador.length < 1
						|| this.dataVerificacion.correo_electronico.trim().length < 1) {
						const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
						const confirmarRespuesta = {} as ConfirmarRespuestaModel;
						confirmarRespuesta.tipoConfirmacionModalType = TipoConfirmacionModalType.Alerta;
						confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
						confirmarRespuesta.buttonTextAlert = 'Entendido';
						// tslint:disable-next-line:max-line-length
						confirmarRespuesta.message = 'El usuario no cuenta con la información suficiente para realizar el registro, comuniquese con soporte.';
						modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
						modalRef.result.then((resultadoModal) => {
							this.formRegistroCuenta.reset();
						}).catch(() => {
							this.formRegistroCuenta.reset();
						});
					}
				},
					(error) => {
						this.formRegistroCuenta.reset();
					});
		}
	}

	onNavigationTerminos(){
		this.router.navigate(['/terminos']);
	}

	resolved(captchaResponse: string) {
	}
}
